/**
 * Help Service
 * 
 * Manages the state and content of the help system.
 */
import { atlasService } from './atlasService';

// Simple event-driven state management for the help modal
const listeners = new Set();

let state = {
    isOpen: false,
    context: 'CAP-000-Getting-Started', // Default to Getting Started
    content: null,
    isLoading: false,
    error: null,
    dockWidth: 400 // Default width
};

export const helpService = {
    setDockWidth(width) {
        state = { ...state, dockWidth: width };
        this.notify();
    },
    async init() {
        await atlasService.init();
        console.log('HelpService initialized with Atlas');
    },

    getState() {
        return { ...(state || { isOpen: false }) };
    },

    subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },

    async openHelp(context) {
        // Use Atlas Service to find the relevant guide
        const guide = atlasService.findGuide(context);
        const fileName = guide ? guide.id : context;

        state = { ...state, isOpen: true, context: fileName, isLoading: true, error: null };
        this.notify();

        try {
            const response = await fetch(`/docs/${fileName}.md`);
            if (!response.ok) throw new Error('Could not load help guide');
            const text = await response.text();

            state = { ...state, content: text, isLoading: false };
        } catch (err) {
            state = { ...state, error: err.message, isLoading: false };
        }
        this.notify();
    },

    closeHelp() {
        state = { ...state, isOpen: false };
        this.notify();
    },

    notify() {
        listeners.forEach(l => l(state));
    },

    search(query) {
        return atlasService.search(query);
    }
};
